import React, { useContext } from "react";
import { Row, Col } from "react-bootstrap";
import { numberFormatter } from "../../components/formatters/numberFormatter";
import { toWords } from "number-to-words";
import { DataContext } from '../../init/getData';

const ReceiptVoucher = React.forwardRef((props, ref) => {
  const {
    journalVoucher,
    vatAmount,
    mainCurrency,
    secondaryCurrency,
    secondaryVatAmount,
  } = props;

  const { settingData } = useContext(DataContext);

  return (
    <div
      ref={ref}
      style={{
        padding: "30px",
        fontFamily: "Arial, sans-serif",
        color: "#333",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <div>
       {/* Header */}
      <div style={{ marginBottom: "30px", borderBottom: "2px solid #ddd", paddingBottom: "20px" }}>
        <Row>
          {/* LEFT SIDE */}
          <Col md={7}>
            <h2 style={{ fontWeight: "bold", fontSize: "1.4rem", margin: "0 0 8px 0" }}>
              {journalVoucher?.company?.name}
            </h2>
            <p style={{ margin: "4px 0", fontSize: "0.9rem" }}>
              <strong style={{ display: "inline-block", width: "70px" }}>Reg:</strong>
              {journalVoucher?.company?.registrationNumber}
            </p>
            <p style={{ margin: "4px 0", fontSize: "0.9rem" }}>
              <strong style={{ display: "inline-block", width: "70px" }}>Address:</strong>
              {journalVoucher?.company?.address}
            </p>
            <p style={{ margin: "4px 0", fontSize: "0.9rem" }}>
              <strong style={{ display: "inline-block", width: "70px" }}>Phone:</strong>
              {journalVoucher?.company?.phone}
            </p>
          </Col>

          {/* RIGHT SIDE */}
          <Col md={5} style={{ textAlign: "right" }}>
            <div style={{ textAlign: "left", display: "inline-block" }}>
              <h2 style={{ fontSize: "1.4rem", margin: "0 0 15px 0", fontWeight: "bold" }}>
                RECEIPT
              </h2>

              <p style={{ margin: "4px 0", fontSize: "0.9rem" }}>
                <strong style={{ display: "inline-block", width: "40px" }}>ID:</strong>
                {journalVoucher?.myId}
              </p>
              <p style={{ margin: "4px 0", fontSize: "0.9rem" }}>
                <strong style={{ display: "inline-block", width: "40px" }}>Ref:</strong>
                {journalVoucher?.id}
              </p>
              <p style={{ margin: "4px 0", fontSize: "0.9rem" }}>
                <strong style={{ display: "inline-block", width: "40px" }}>Date:</strong>
                {journalVoucher?.date}
              </p>
            </div>
          </Col>

        </Row>
      </div>


        {/* Received From */}
        {/* Billed To Section - Split Left/Right */}
        <div style={{ marginTop: "50px", marginBottom: "25px" }}>
          <div
            style={{
              border: "1px solid #ccc",
              borderRadius: "0px",
              padding: "15px 15px",
              backgroundColor: "transparent",
            }}
          >
            <Row>
              <Col md={6}>
                <div style={{ padding: "10px", border: "none" }}>
                  <h3
                    style={{
                      fontSize: "1rem",
                      margin: "0 0 7px 0",
                      fontWeight: "bold",
                    }}
                  >
                    Received From:
                  </h3>

                  <p style={{ margin: "4px 0", fontSize: "0.9rem" }}>
                    <strong>Name:</strong> {journalVoucher?.account?.english}
                  </p>

                  <p style={{ margin: "4px 0", fontSize: "0.9rem" }}>
                    <strong>Reg:</strong> {journalVoucher?.account?.registration}
                  </p>
                </div>
              </Col>

              <Col md={6}>
                <div
                  style={{
                    padding: "10px",
                    border: "none",
                    textAlign: "right",
                  }}
                >
                  <h3
                    style={{
                      fontSize: "1rem",
                      margin: "0 0 7px 0",
                      fontWeight: "bold",
                      visibility: "hidden", // keeps vertical alignment
                    }}
                  >
                    Billed To:
                  </h3>

                  <p style={{ margin: "4px 0", fontSize: "0.9rem" }}>
                    <strong>Address:</strong> {journalVoucher?.account?.address}
                  </p>

                  <p style={{ margin: "4px 0", fontSize: "0.9rem" }}>
                    <strong>Phone:</strong> {journalVoucher?.account?.phone}
                  </p>
                </div>
              </Col>
            </Row>
          </div>
        </div>



        {/* Amount Section */}
        <div
            style={{
                border: "1px solid #000000ff",
                padding: "20px",
                marginTop: "100px", 
                marginBottom: "60px",
                backgroundColor: "transparent",
            }}
            >
          <Row>
            <Col md={6}>
              <p style={{ fontSize: "1rem", marginBottom: "8px", color: '#000' }}>
                <strong>Amount:</strong>{" "}
                {/* Conditionally show mainCurrency based on settingData?.printCurrencyRate */}
                {settingData?.printCurrencyRate && (
                  <>
                    {numberFormatter(journalVoucher?.totalDebit || 0)} {mainCurrency?.symbol}
                    {secondaryCurrency && " / "}
                  </>
                )}
                {secondaryCurrency && (
                  <>
                    {numberFormatter(journalVoucher?.secondaryTotalDebit || 0)} {secondaryCurrency?.symbol}
                  </>
                )}
              </p>
              <p
                style={{
                  margin: "6px 0",
                  fontSize: "0.9rem",
                  color: "#000",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
              
                }}
              >
                <strong>Only:</strong>{" "}
                {/* Conditionally show text based on settingData?.printCurrencyRate */}
                {settingData?.printCurrencyRate 
                  ? `${toWords(journalVoucher?.totalDebit || 0)} ${ mainCurrency?.symbol || ''}`  // Show main currency text
                  : `${toWords(journalVoucher?.secondaryTotalDebit || 0)} ${secondaryCurrency?.symbol || ''}`  // Show secondary currency text
                }
              </p>
               <p style={{ fontSize: "1rem", marginBottom: "8px", color: '#000' }}>
                <strong>Description:</strong>{" "}
                {journalVoucher?.details}
              </p>
            </Col>
           
          </Row>
        </div>
      </div>

      {/* Signature Footer */}
     <footer style={{ borderTop: "1px solid #ccc", paddingTop: "20px" }}>
      <Row>
        <Col md={{ span: 4, offset: 8 }} style={{ textAlign: "left", color: "#000" }}>
          <p style={{ margin: "5px 0", fontWeight: "bold" }}>Receiver Signature:</p>
          <p style={{ margin: "25px 0 5px 0" }}>_________________________</p>
        </Col>
      </Row>
    </footer>

        </div>
      );
    });

export default ReceiptVoucher;